import { React, useState, useEffect } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import LeaseApiService from '../../services/apiService';
import { AsyncPaginate } from 'react-select-async-paginate';

const MasterDetails = ({
  tableLoading,
  setTransectionData,
  setunitCategoryList,
  contactPerson,
  setFeaturesList,
  transectionData,
  propertyList,
  unitTypeList,
  unitCategoryList,
  readOnly = false,
}) => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  const ITEMS_PER_PAGE = 100;

  const handleInputChange = (input) => {
    const name = input?.target?.name || input.name;
    const value = input?.target?.value || input.value;

    setTransectionData((prev) => {
      const updatedData = { ...prev, [name]: value };
      return updatedData;
    });
  };
  const handleDropDownChange = async ({ name, value }) => {
    if (name === 'property') {
      const scndparams = new URLSearchParams();
      scndparams.append('Action', 'GetUnitfeatuersByPropertyNo');
      scndparams.append('PropertyNo', value?.value?.value);
      const scndRes = await apiService.getApiParamater('GET_UNIT_COMMON', `?${scndparams.toString()}`);
      setFeaturesList(scndRes?.data?.result?.data);
      setTransectionData((prev) => ({ ...prev, [name]: value }));
      return;
    }
    if (name === 'unitType') {
      const comParam = new URLSearchParams();
      comParam.append('DropdownFor', 'UMUnitCategoriesByType');
      comParam.append('CascadValue', value?.label);
      const commRes = await apiService.getApiParamater('GET_UNIT_CASCAD', `?${comParam.toString()}`);
      setunitCategoryList(commRes?.data?.items || []);
      setTransectionData((prev) => ({
        ...prev,
        unitType: value,
        unitCategory: null,
      }));
      return;
    }
    setTransectionData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <div className="cost-center-section my-3">
      <div className={`border-box2 p-3`}>
        {tableLoading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            <div className="spinner-border text-primary" role="status" />
          </div>
        )}
        <fieldset disabled={readOnly} style={{ border: 'none', padding: 0, margin: 0 }}>
        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              {t('unitMaster.masterDetailsFields.property')} *
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.property}
              onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
              options={propertyList?.map((country) => ({ value: country, label: country?.text }))}
              isDisabled={readOnly}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {' '}
              {t('unitMaster.masterDetailsFields.mobileNo')}
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.mobile} onChange={handleInputChange} name="mobile" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {t('unitMaster.masterDetailsFields.totalValue')}
            </label>
            <input type="number" className="p-2 form-control w-75" value={transectionData?.totalvalue} onChange={handleInputChange} name="totalvalue" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {' '}
              {t('unitMaster.masterDetailsFields.unitNo')} *
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.unitNo} onChange={handleInputChange} name="unitNo" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              {t('unitMaster.masterDetailsFields.contactPerson')}
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.contactPerson}
              onChange={(selectedOption) => handleDropDownChange({ name: 'contactPerson', value: selectedOption })}
              options={contactPerson?.map((country) => ({ value: country, label: country?.text }))}
              isDisabled={readOnly}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {t('unitMaster.masterDetailsFields.roundOffValue')} *
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.roundoff} onChange={handleInputChange} name="roundoff" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              {t('unitMaster.masterDetailsFields.unitType')} *
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.unitType}
              onChange={(selectedOption) => handleDropDownChange({ name: 'unitType', value: selectedOption })}
              options={unitTypeList?.map((country) => ({ value: country, label: country?.text }))}
              isDisabled={readOnly}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {t('unitMaster.masterDetailsFields.unitCategory')} *
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.unitCategory}
              onChange={(selectedOption) => handleDropDownChange({ name: 'unitCategory', value: selectedOption })}
              options={unitCategoryList?.map((country) => ({ value: country, label: country?.text }))}
              isDisabled={readOnly}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {t('unitMaster.masterDetailsFields.notes')}
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.notes} onChange={handleInputChange} name="notes" />
          </div>
        </div>
        </fieldset>
      </div>
    </div>
  );
};
export default MasterDetails;
